import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { hasModuleAccess, useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ roles, module, children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <div className="text-zinc-500 text-sm tracking-widest uppercase">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc }} />;
  if (roles && !roles.includes(user.role))
    return <Navigate to={user.role === "patient" ? "/portal" : "/staff"} replace />;
  if (module && !hasModuleAccess(user, module))
    return <Navigate to={user.role === "patient" ? "/portal" : "/staff"} replace />;
  return children;
}
